import AddIcon from "@mui/icons-material/Add";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import OpacityIcon from "@mui/icons-material/Opacity";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import {
  Checkbox,
  CircularProgress,
  Container,
  IconButton,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { SubmitHandler, useForm } from "react-hook-form";
import { Configure, Hits, InstantSearch, useHits, useInstantSearch } from "react-instantsearch";
import { useHistory, useParams, useLocation } from "react-router";
import Cookies from "universal-cookie";
import "../../App.css";
import Constant from "../../Constant";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import AccountTransferCrossIcon from "../../assets/images/icons/AccountTransferCrossIcon.svg";
import AccountTransferIcon from "../../assets/images/icons/AccountTransferIcon.svg";
import ShippingCrossIcon from "../../assets/images/icons/LocalShippingCrossIcon.svg";
import WhiskyBarrelBig from "../../assets/images/products/WhiskyBarrelBig.png";
import { createTypesenseAdapter } from "../../typesenseAdapter";
import "../Dynamic/ProductDetail.scss";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import "../popups/CommonPopup.scss";
// import Spinner from "../Common/Spinner";
import { darken } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import CKContent from "../Common/CKcontent";
import { useRoute } from "../Common/route";
import { RootState } from "../store";
import { setMyCartItems, setProductName } from "../store/cartSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProductionQuantityLimitsOutlinedIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined';

import barrel_1_2_a from '../../assets/images/facilities_images/1-2/1_2_a.png';
import barrel_2_3_a from '../../assets/images/facilities_images/2-3/2_3_a.png';
import barrel_3_4_a from '../../assets/images/facilities_images/3-4/3_4_a.png';
import barrel_4_5_a from '../../assets/images/facilities_images/4-5/4_5_a.png';
import barrel_5_6_a from '../../assets/images/facilities_images/5-6/5_6_a.png';
import barrel_6_7_a from '../../assets/images/facilities_images/6-7/6_7_a.png';
import barrel_7_8_a from '../../assets/images/facilities_images/7-8/7_8_a.png';
import barrel_8_9_a from '../../assets/images/facilities_images/8-9/8_9_a.png';
import barrel_9_10_a from '../../assets/images/facilities_images/9-10/9_10_a.png';
import barrel_10_11_a from '../../assets/images/facilities_images/10-11/10_11_a.png';
import barrel_11_12_a from '../../assets/images/facilities_images/11-12/11_12_a.png';
import barrel_12_13_a from '../../assets/images/facilities_images/12-13/12_13_a.png';
import barrel_13_14_a from '../../assets/images/facilities_images/13-14/13_14_a.png';
import barrel_14_15_a from '../../assets/images/facilities_images/14-15/14_15_a.png';
import barrel_15_16_a from '../../assets/images/facilities_images/15-16/15_16_a.png';
import barrel_16_17_a from '../../assets/images/facilities_images/16-17/16_17_a.png';
import barrel_17_18_a from '../../assets/images/facilities_images/17-18/17_18_a.png';
import barrel_18_19_a from '../../assets/images/facilities_images/18-19/18_19_a.png';
import barrel_19_20_a from '../../assets/images/facilities_images/19-20/19_20_a.png';
import barrel_20_21_a from '../../assets/images/facilities_images/20-21/20_21_a.png';
import barrel_21_22_a from '../../assets/images/facilities_images/21-22/21_22_a.png';
import barrel_22_23_a from '../../assets/images/facilities_images/22-23/22_23_a.png';
import barrel_23_24_a from '../../assets/images/facilities_images/23-24/23_24_a.png';
import barrel_24_25_a from '../../assets/images/facilities_images/24-25/24_25_a.png';
import barrel_25_plus_a from '../../assets/images/facilities_images/25_plus/25_plus_a.png';

const ProductImage = styled("img")({
  maxWidth: "100%",
  border: "1px solid #D9D9D9", // 1px border for the image
  borderRadius: "10px",
});

const ProductCaption = styled(Typography)({
  textAlign: "center",
  marginTop: "8px",
});

const useStyles = makeStyles({
  root: {
    boxShadow: "none",
  },
  firstColumn: {
    minWidth: 115,
    width: "max-content",
    borderBottom: "none",
    color: "#496673",
    fontSize: "14px",
    fontWeight: "700",
    backgroundColor: "transparent",
  },
  secondColumn: {
    width: "100%",
    borderBottom: "none",
    color: "#242424",
    backgroundColor: "transparent",
    "& .taste-precentage": {
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "22px",
      letterSpacing: "0",
      color: "#242424",
      marginBottom: 0,
      "& .MuiSlider-root": {
            padding: "unset",
      }
    },
  },
});

type FormValue = {
  quantity: number;
  pricePerBarrel: number;
  comment: string;
  inventoryId: string;
  status: string;
  ownerStatus: string;
  handlingFee: number;
  serviceFee: number;
  totalAmount: number;
  inventoryName: string;
  isAccountTransfer: boolean;
  isRelocationRequired: boolean;
  isThirdPartyStorage: boolean;
  companyId: string;
};

const ProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [dynamicSearchClient, setDynamicSearchClient] = useState(null);
  const [globalFilter, setGlobalFilter] = useState<string>("");
  const collectionName = process.env.REACT_APP_TYPESENSE_COLLECTIONNAME; //Typesense collection name

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  useEffect(() => {
    console.log("Added");
    const filters = [
      `id:${id}`,
      "is_active:=true",
      "is_delete:=false"
    ];

    // Generate dynamic filter string
    const filterValue = filters.join(",");
    setGlobalFilter(filterValue);
    // Create a new TypesenseInstantsearchAdapter instance with dynamic filter
    const dynamicAdapter = createTypesenseAdapter();

    // // Set searchClient to state
    setDynamicSearchClient(dynamicAdapter.searchClient);
  }, []);

  if (!dynamicSearchClient) {
    return <div>Loading...</div>;
  }

  return (
    <InstantSearch searchClient={dynamicSearchClient} indexName={collectionName}>
      <Configure filters={globalFilter} />
      <CustomHits>
        <Hits hitComponent={HitItem} />
      </CustomHits>
    </InstantSearch>
  );
};

const HitItem: React.FC<{ hit: any }> = ({ hit }) => {
  const classes = useStyles();
  const [count, setCount] = React.useState(1);
  const [existingCount, setExistingCount] = React.useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isInWishlist, setIsInWishlist] = useState<boolean | null>(null);
  const [isOffer, setIsOffer] = useState<boolean | null>(false);
  const [isSample, setIsSample] = useState<boolean | null>(false);
  const [formData, setFormData] = useState<FormValue>({
    quantity: 0,
    pricePerBarrel: 0,
    comment: "",
    inventoryId: hit.id,
    status: "PENDING_REVIEW",
    ownerStatus: "ACTION_REQUIRED",
    handlingFee: 0,
    serviceFee: 0,
    totalAmount: 0,
    inventoryName: hit.product_name,
    isAccountTransfer: hit.is_account_transfer,
    isRelocationRequired: hit.is_relocation_required,
    isThirdPartyStorage: hit.is_third_party_storage,
    companyId: CommonService.getCompanyId()
  });

  const userId = new Cookies().get("userId");
  const [multipleBarrels, setMultipleBarrels] = useState<string>("");
  const [multiplelots, setMultiplelots] = useState<string>("");
  const [purpose, setPurpose] = useState<string>("");
  const [size, setSize] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [quantity, setQuantity] = useState<any>(null);
  const [descriptionError, setDescriptionError] = useState<string>("");
  const [isSampleOrderRequestCreated, setSampleOrderRequestCreated] =
    useState<boolean>(false);
  const [isSampleOrderRequestUpdated, setSampleOrderRequestUpdated] =
    useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [sampleRequestValidate, setSampleRequestValidate] = useState(false);
  const [offerRequestValidate, setOfferRequestValidate] = useState(false);
  const [isShowViewCart, setIsShowViewCart] = useState(false);
  const [orderItemsInCart, setOrderItemsInCart] = useState<any>(null);
  const myCartItems = useSelector((state: RootState) => state.cart.myCartItems);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const route = useRoute();
  const [sampleRequestError, setSampleRequestError] = useState({
    purpose: "",
    multipleBarrels: "",
    multipleLots: "",
    size: "",
    quantity: "",
    requestNote: ""
  });

  const validateSampleRequestFields = () => {
    //validate all the fields and set the error if have and return true of false 

    let isValid = true;
    let errors = {
      purpose: "",
      multipleBarrels: "",
      multipleLots: "",
      size: "",
      quantity: "",
      requestNote: ""
    };

    // Validate purpose
    if (!purpose || purpose.trim().length === 0) {
      errors.purpose = "Please enter your purpose";
      isValid = false;
    }

    // Validate multipleBarrels
    if (!multipleBarrels) {
      errors.multipleBarrels = "Multiple container are required";
      isValid = false;
    }

    // Validate multipleLots
    if (!multiplelots) {
      errors.multipleLots = "Multiple lots are required";
      isValid = false;
    }

    // Validate size
    if (!size) {
      errors.size = "Please enter size";
      isValid = false;
    }

    // Validate quantity
    if (!quantity || isNaN(quantity) || quantity <= 0) {
      errors.quantity = "Please enter quantity";
      isValid = false;
    }

    //Validate request note
    if (description.trim().length == 0) {
      errors.requestNote = "Please enter request note";
      isValid = false;

    }

    setSampleRequestError(errors);
    return isValid;

  }

  let orderItems: any;
  orderItems = {
    inventoryId: hit.inventory_id,
    inventoryTitle: hit.product_name,
    price: hit.price,
    quantity: count,
    totalPrice: hit.price * count,
    serviceFee: 0,
    handlingFee: 0,
    // handlingFee: hit.is_relocation_required == true ? count * 10 : 0,
    // serviceFee: (hit.is_account_transfer == true ? 10 : 0)+(hit.is_third_party_storage == true ? count*10 : 0),
    // serviceFee: Math.min(CommonService.isFacilityMatch(hit?.facility) ? 0 : (hit.is_account_transfer == true ? 10 * count : 0), 5000),
    isRelocationRequiredByOwner: hit.is_relocation_required,
    isAccountTransferByOwner: hit.is_account_transfer,
    isRelocationRequiredByBuyer: hit.is_relocation_required,
    isAccountTransferByBuyer: hit.is_account_transfer,
    isThirdPartyStorage: hit.is_third_party_storage,
    ownerOrderStatus: 'ACTION_REQUIRED',
    platformFee: hit.platform_fee,
    feeType: hit.fee_type,
    companyId: CommonService.getCompanyId(),
    inventoryOwner: hit.owner_name
  };

  const wishListRequest = {
    inventoryId: hit.inventory_id,
    userId: userId,
    inventoryTitle: hit.product_name,
  };

  const handleQuanityChange = (e: any) => {
    sampleRequestError.quantity = "";
    const newCount = parseInt(e.target.value);
    console.log(newCount);

    // Validate the range before updating the state
    if (!isNaN(newCount)) {
      if (newCount < 1) {
        setCount(1);
        setErrorMessage("");
      } else if (newCount > 99999) {
        setCount(99999);
        setErrorMessage("");
      } else {
        setCount(newCount);
        setErrorMessage("");
      }
    } else {
      setCount(1);
      setErrorMessage("");
    }
  };

  useEffect(() => {
    dispatch(setProductName(hit.state + " " + hit.ttb_type+ " " + hit.product_name));
    console.log("call use Effect");
    isInventoryInWishlist();
    isInventoryInCartForUser();
  }, []);

  const isInventoryInWishlist = async () => {
    try {
      const isInWishlistValue = await OrderApiService.isInventoryInWishlist(
        hit.inventory_id
      );
      setIsInWishlist(isInWishlistValue.data);
    } catch (error) {
      console.error("Error while fetching wishlist:", error);
    }
  };

  const isInventoryInCartForUser = async () => {
    try {
      const orderItemsInCart : any = await OrderApiService.isInventoryInCartForUser(hit.inventory_id);
      console.log("Response for isInventoryInCartForUser:", orderItemsInCart.data);

      if (orderItemsInCart.data.length > 0) {
        console.log(true);
        setOrderItemsInCart(orderItemsInCart.data[0]);
        setExistingCount(orderItemsInCart.data[0].quantity);
        setCount(orderItemsInCart.data[0].quantity);
        setIsShowViewCart(true);
      } else {
        console.log(false)
        setIsShowViewCart(false);
      }

    } catch (error) {
      console.error("Error while checking if inventory is in cart:", error);
    }
  };

  const addToCart = async () => {
    // Restrict access to Super Admins and users belonging to the same company as the inventory
    if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
      return ;
    }
    if(isShowViewCart && (existingCount == count)){
      route("/user/my-cart");
    }else{
      try {
        if(orderItemsInCart)
          orderItems.id = orderItemsInCart.id
        
        const response = await OrderApiService.saveOrderItems(orderItems);
        console.log(response.data);
        CommonService.Toast.fire({
          title:"Inventory item added to your cart!",
          icon: "success"
        });

        if(!orderItems.id){
          //increment count for new item for profile on add
          dispatch(setMyCartItems(myCartItems + 1));
        }
        
        route("/user/inventories");
      } catch (error) {
        console.log(error);

        if(error?.response?.data?.errorMessage == 'This inventory is no longer available in marketplace') {
          CommonService.Toast.fire({
            title: "This inventory is no longer available in Marketplace",
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: "There is some technical problem, please try again later.",
            icon: "error",
          });
        }
      } finally {
        setIsLoading(false);
      }
    }
    
  };

  const manageWishList = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {

    // Restrict access to Super Admins and users belonging to the same company as the inventory
    if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
      return ;
    }

    if (isInWishlist) {
      const success = await removeFromWishList();
      if (success) {
        setIsInWishlist(false);
      }
    } else {
      const success = await addToWishList();
      if (success) {
        setIsInWishlist(true);
      }
    }
  };

  const addToWishList = async (): Promise<boolean> => {
    try {
      const response: any = await OrderApiService.addToWishlist(wishListRequest);
      return true;
    } catch (error) {
      console.error("Error while adding wishlist data:", error);

      if (error?.response?.data?.errorMessage === 'This inventory is no longer available in marketplace') {
        CommonService.Toast.fire({
          title: "This inventory is no longer available in Marketplace",
          icon: "error",
        });
      }

      return false;
    }
  };

  const removeFromWishList = async (): Promise<boolean> => {
    try {
      const response: any = await OrderApiService.removeFromWishlist(wishListRequest);
      return true;
    } catch (error) {
      console.error("Error while removing wishlist data:", error);
      return false;
    }
  };

  function calculateWidth(
    count: number
  ): import("csstype").Property.Width<string | number> | undefined {
    const countLength = count.toString().length;
    if (countLength <= 2) {
      return "30px"; // Base width + some increment for 2 digits
    } else if (countLength === 3) {
      return "35px"; // More width for 3 or more digits
    } else if (countLength === 4) {
      return "40px"; // More width for 3 or more digits
    }
    return "45px"; // Base width for 1 digit
  }

  const handleOfferShow = async () => {

    if(!isOffer) {
      // Restrict access to Super Admins and users belonging to the same company as the inventory
      if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
        return ;
      }
    }
    setIsOffer(!isOffer);
    setIsSample(false);
    setOfferRequestValidate(false);
    formData.handlingFee = 0;
    formData.serviceFee = 0;
    formData.totalAmount = formData.serviceFee;
    formData.quantity = null;
    formData.pricePerBarrel = null;
  };

  const handleRequestShow = () => {

    if(!isSample) {
      // Restrict access to Super Admins and users belonging to the same company as the inventory
      if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
        return ;
      }
    }
    setIsSample(!isSample);
    setIsOffer(false);
    setSampleRequestValidate(false);
    if (isSample === true) handleRequestSampleCancel();

    setQuantity(0);
    setMultipleBarrels("");
    setMultiplelots("");
    setPurpose("");
    setSize("");
    setDescription("");
    setDescriptionError("");

    //checkSampleOrderStatus();
  };

  //call the service and check user is already created sample order request or not
  const checkSampleOrderStatus = async () => {
    try {
      const sampleOrder = {
        inventoryId: id,
      };
      const response = await OrderApiService.isSampleRequestCreated(
        sampleOrder
      ).then((response) => {
        const data = response.data;
        if (data != "") {
          console.log(response.data);
          setStatus(true);
          setPurpose(data.purpose);
          setMultipleBarrels(data.multipleBarrels === true ? "yes" : "no");
          setMultiplelots(data.multiplelots === true ? "yes" : "no");
          setSize(data.size);
          setQuantity(data.quantity);
          setDescription(data.comment);
        }
      });
    } catch (error) {
      console.log("error occured while status checking");
      setDescription("");
    }
  };

  const handlePriceChange = (event: any) => {
    let inputValue = event.target.value.trim();
 
    inputValue = inputValue.replace(/^0+/, '') || '0';

    const value = Number(inputValue);
    let newPrice = 0;
    let isValid = true;

    // Check if the input value is a valid number and greater than 0
    if (inputValue === "" || isNaN(value) || value < 1) {
      isValid = false;
    } else {
      newPrice = value;
    }

    // Update the state only if the input is valid
    if (isValid) {
      const totalAmount = newPrice * formData.quantity + (formData.handlingFee + formData.serviceFee);

      setFormData((prevData) => ({
        ...prevData,
        pricePerBarrel: newPrice,
        totalAmount: totalAmount,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        pricePerBarrel: 0,
      }));
    }
};


  const handleQuantityChange = (event: any) => {
    sampleRequestError.quantity = "0";
    const inputValue = event.target.value.trim();
    const value = Number(inputValue);

    let handleFee = 0;
    let totalAmount = 0;
    let serviceFee = 0;
    console.log("Relocation status " + formData.isRelocationRequired);


    if (inputValue !== "" && !isNaN(value) && value > 0) {
      // handleFee = formData.isRelocationRequired ? 10 * value : 0;
      // serviceFee = Math.min(formData.isAccountTransfer ? 10 * value : 0, 5000);
      totalAmount = value * formData.pricePerBarrel + (handleFee + serviceFee);
    }



    // const handleFee = orderItems.isRelocationRequired ? 10 * newQuantity : 0;
    // const totalamount = newQuantity * formData.pricePerBarrel + (handleFee + formData.serviceFee);

    setFormData((prevData) => ({
      ...prevData,
      quantity: value,
      handlingFee: handleFee,
      serviceFee: serviceFee,
      totalAmount: totalAmount,
    }));

  };

  const offerRequest: SubmitHandler<FormValue> = async () => {

    setOfferRequestValidate(true);
    if (formData.quantity && formData.pricePerBarrel) {
      setIsLoading(true);
      try {
        // Call the service
        const response = await OrderApiService.savePurchaseOffer(formData);
        handleOfferShow();
        console.log("Data saved successfully: ", response);
        CommonService.Toast.fire({
          title: "Offer made successfully",
          icon: "success",
        });
      } catch (error) {
        console.error("Error occurred while saving the data: ", error);
        if(error?.response?.data?.errorMessage == 'This inventory is no longer available in marketplace') {
          CommonService.Toast.fire({
            title: "This inventory is no longer available in Marketplace",
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: "There is some technical problem, please try again later.",
            icon: "error",
          });
        }
      } finally {
        setIsLoading(false);
        setSampleRequestError({
          purpose: "",
          multipleBarrels: "",
          multipleLots: "",
          size: "",
          quantity: "",
          requestNote: ""
        });
      }
    }
  };

  const handleOfferCancel = async () => {
    setIsOffer(false);
    setOfferRequestValidate(false);
    formData.quantity = null;
    formData.pricePerBarrel = null;
    formData.comment = "";
    formData.inventoryId = hit.id;
    formData.inventoryName = hit.product_name;
    formData.status = "PENDING_REVIEW";
    formData.handlingFee = 0;
    formData.serviceFee = 0;
    formData.totalAmount = 0;
    formData.isRelocationRequired = hit.is_relocation_required;
    formData.isAccountTransfer = hit.is_account_transfer;
    formData.isThirdPartyStorage = hit.is_third_party_storage;
    formData.companyId = CommonService.getCompanyId()
  };

  const handleRequestSampleCancel = async () => {
    setIsSample(false);
    setQuantity(0);
    setMultipleBarrels("");
    setMultiplelots("");
    setPurpose("");
    setSize("");
    setDescription("");
    setDescriptionError("");
    setSampleRequestValidate(false);
    setSampleOrderRequestCreated(false);
    setSampleOrderRequestUpdated(false);
  };

  const handlePurposeDropdown = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    sampleRequestError.purpose = "";
    setPurpose(event.target.value);
  };

  function handleRadioChange1(event: ChangeEvent<HTMLInputElement>): void {
    sampleRequestError.multipleBarrels = "";
    setMultipleBarrels(event.target.value);
  }

  function handleRadioChange2(event: ChangeEvent<HTMLInputElement>): void {
    sampleRequestError.multipleLots = "";
    setMultiplelots(event.target.value);
  }

  const handleSizeDropdown = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sampleRequestError.size = "";
    setSize(event.target.value);
  };



  const handleInputTextChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    // Remove leading zero when typing
    if (value === "") {
      setQuantity("0"); 
    } else if (/^\d+$/.test(value)) {
      setQuantity(value.replace(/^0+/, ""));
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;

    // Allow only numeric input and essential keys
    const isAllowed =
      key === "Backspace" || 
      key === "Delete" || 
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      /^[0-9]$/.test(key);

    if (!isAllowed) {
      event.preventDefault();
    }
  };
  
  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    sampleRequestError.requestNote = "";
    console.log(value);
    setDescription(value);
    //check the length of description
    if (!value?.trim()) {
      setDescriptionError("Description is required");
    } else if (value.trim().length > 500) {
      setDescriptionError("Description can't greater then 500 characters.");
    } else {
      setDescriptionError("");
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValue>();

  //handle submit
  const requestSample: SubmitHandler<FormValue> = async () => {
    console.log("inside request submit");

    if (!validateSampleRequestFields()) {
      return;
    }

    setSampleRequestValidate(true);
    //validate description
    if (description.trim() && description.length > 0) {
      console.log("Description:", description);
      console.log("Id is", hit.id);

      if (multiplelots && multipleBarrels && size && purpose && quantity) {
        const sampleOrder = {
          description: description,
          inventoryId: hit.id,
          inventoryName: hit.product_name,
          purpose: purpose,
          multipleBarrels: multipleBarrels == "yes" ? true : false,
          multiplelots: multiplelots == "yes" ? true : false,
          size: size,
          quantity: quantity,
          sampleRequestStatus: Constant.SampleRequestStatus.PENDING_REVIEW,
          ownerStatus: Constant.SampleRequestStatus.ACTION_REQUIRED,
          companyId: CommonService.getCompanyId()
        };

        console.log(sampleOrder);

        //call the new Sample Order Request api
        console.log("created api");
        addSampleOrderRequest(sampleOrder);
        setSampleOrderRequestCreated(true);

        //check the status
        // if (status == true) {
        //   //call the update api
        //   console.log("updated called");
        //   updateSampleOrderRequest(sampleOrder);
        //   setSampleOrderRequestUpdated(true);
        // }
      }
    } else {
      setDescriptionError("description is required");
    }
  };

  const addSampleOrderRequest = async (sampleOrder: any) => {
    setIsLoading(true);
    try {
      //call the service
      const response = await OrderApiService.saveSampleRequest(
        sampleOrder
      ).then((response) => {
        setIsSample(false);
        setIsLoading(false);
        CommonService.Toast.fire({
          title: "Your request is successfully submitted.",
          icon: "success",
        });
      });
    } catch (error) {
      setIsLoading(false);
      console.log("error adding the sample order request" + error);

      if(error?.response?.data?.errorMessage == 'This inventory is no longer available in marketplace') {
        CommonService.Toast.fire({
          title: "This inventory is no longer available in Marketplace",
          icon: "error",
        });
      } else {
        CommonService.Toast.fire({
          title: "There is some technical problem, please try again later.",
          icon: "error",
        });
      }

    }
  };

  const updateSampleOrderRequest = async (sampleOrder: any) => {
    setIsLoading(true);
    try {
      const response = OrderApiService.updateSampleRequest(sampleOrder).then(
        (response) => {
          setIsSample(false);
          setIsLoading(false);
          CommonService.Toast.fire({
            title: "Your request is successfully updated.",
            icon: "success",
          });
        }
      );
    } catch (error) {
      console.log("error occurred in sample order request updation");
      setIsLoading(false);
      CommonService.Toast.fire({
        title: "There is some technical problem, please try again later.",
        icon: "error",
      });
    }
  };

  const manageHandlingFees = async (event) => {

    const isChecked = event.target.checked;
    if (isChecked) {
      // console.log("Checked >>>>>>>>>>>>>>>>");
      // const handleFee = 10 * formData.quantity;
      // const total = formData.totalAmount + handleFee;

      // console.log("total fees " + total);

      // setFormData((prevData) => ({
      //   ...prevData,
      //   handlingFee: handleFee,
      //   totalAmount: total,
      //   isRelocationRequired: true,
      // }));
      formData.isRelocationRequired = true;
    } else {

      // console.log("Checked >>>>>>>>>>>>>>>>");
      // console.log("handling fees " + formData.handlingFee);
      // const total =
      //   formData.totalAmount === 0
      //     ? 0
      //     : formData.totalAmount - formData.handlingFee;
      // const handleFee = 0;

      // setFormData((prevData) => ({
      //   ...prevData,
      //   totalAmount: total,
      //   handlingFee: handleFee,
      //   isRelocationRequired: false,
      // }));
      formData.isRelocationRequired = false;
    }
  };

  const manageServiceFees = async (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // const serviceFee = Math.min(10 * formData.quantity, 5000);
      // const total = formData.totalAmount + serviceFee;

      // setFormData((prevData) => ({
      //   ...prevData,
      //   serviceFee: serviceFee,
      //   totalAmount: total,
      //   isAccountTransfer: true,
      // }));

      setFormData((prevData) => ({
          ...prevData,
          isAccountTransfer: true,
        }));
    } else {
      // const total = formData.totalAmount === 0  ? 0 : formData.totalAmount - formData.serviceFee;
      // const serviceFee = 0;

      // setFormData((prevData) => ({
      //   ...prevData,
      //   serviceFee: serviceFee,
      //   totalAmount: total,
      //   isAccountTransfer: false,
      // }));

      setFormData((prevData) => ({
        ...prevData,
        isAccountTransfer: false,
      }));
    }
  };

  const { years, months } = CommonService.calculateAge(hit.fill_date_timestamp);

  // Calculate total years as a float (if you have months, add as fraction)
  const ageInYears = Number(years) + Number(months || 0) / 12;

  const barrelImages: string[] = [
    barrel_1_2_a, barrel_2_3_a, barrel_3_4_a, barrel_4_5_a, barrel_5_6_a,
    barrel_6_7_a, barrel_7_8_a, barrel_8_9_a, barrel_9_10_a, barrel_10_11_a,
    barrel_11_12_a, barrel_12_13_a, barrel_13_14_a, barrel_14_15_a, barrel_15_16_a,
    barrel_16_17_a, barrel_17_18_a, barrel_18_19_a, barrel_19_20_a, barrel_20_21_a,
    barrel_21_22_a, barrel_22_23_a, barrel_23_24_a, barrel_24_25_a, barrel_25_plus_a
  ];

  const getAgeIndex = (years: number, months: number = 0): number => {
    const age = years + months / 12;
    let index = Math.floor(age) - 1; // Map 1-2 → index 0, 2-3 → index 1, etc.
    if (index < 0) index = 0;
    if (index >= barrelImages.length) index = barrelImages.length - 1; // 25+
    return index;
  };

  const selectedImage = useMemo(() => {
    const ageIndex = getAgeIndex(ageInYears);
    return barrelImages[ageIndex]; // Directly return the string
  }, [ageInYears]);

  const handleEditSellRequest = (customerServiceRequestId:any) => {
      history.push(`${CommonService.isUser() ? '/user' : '/master'}` + `/edit-customer-service-request/${customerServiceRequestId}`);
  }

  const handleBack = () => {
    if (
      history.action === "PUSH" ||
      history.action === "REPLACE" ||
      (location.state && (location.state as any).fromInternal)
    ) {
      history.goBack();
    } else {
      history.push(CommonService.isAdmin() ? '/master/inventories' : '/user/inventories');
    }
  };

  return (
    <>
      {/* Start */}
      <section className={`ProductDetail  mb-0 mt-0 ${CommonService.isAdmin() && "admin-detail__container"}`}>
        {CommonService.isAdmin() && (<div className="header-wrapper">
                    <><div className="d-flex align-items-center gap-2">
                      <div className="back__button" onClick={handleBack}>
                        <IconButton
                          aria-label="ArrowBackIcon"
                          sx={{ backgroundColor: "#FFF" }}
                        >
                          <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                        </IconButton>
                      </div><Typography
                        variant="h1"
                        gutterBottom
                        className='mb-0'
                        sx={{
                          fontSize: "24px",
                          fontWeight: 700,
                          color: "#242424",
                          lineHeight: "22px",
                        }}
                      >
                        Marketplace
                      </Typography>
                    </div>
                    </>
                  </div>
                  )}
                  <div className='detail-inner'>
        <div className="container my-3">
          {/* <div className="col-lg-12 mb-3">
              <Box
                sx={{
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    border: "1px solid #D9D9D9",
                    width: "100%",
                    height: "350px",
                  }}
                >
                  <ProductImage
                    src={CircleBarrel}
                    alt="Product Image"
                    sx={{ mx: "auto", border: "none", alignSelf: "center" }}
                    width={112}
                    height={112}
                  />
                </Box>
                <ProductCaption variant="body2">
                  <LocalShippingOutlinedIcon sx={{ color: "#7E84A3", mr: 1 }} />
                  Relocation Not Required
                </ProductCaption>
              </Box>
            </div> */}
          <div className="row d-flex mb-5">
            <div className="col-12 col-lg-6 mb-5 mb-lg-0">
              <div className="product__img d-flex justify-content-center">
                <img src={selectedImage} alt="WhiskyBarrelBig" />
                {/* Start (Hide This My Listing On Conditionally) */}
                {CommonService.getCompanyId() == hit.company_id &&
                hit?.customer_service_request_id &&
                CommonService.isUser() && (
                  <>
                  <div className='my-listing-wrapper'>
                  <span className='text'>My Listing</span>
                    <span onClick={(e) => {
                        e.stopPropagation();
                        handleEditSellRequest(
                          hit?.customer_service_request_id
                        );
                      }} className="img-wrapper">
                      <Tooltip title="Edit My Listing" arrow>
                        <img
                          src={EditIcon}
                          className="cursor-pointer"
                          alt="EditIcon"
                        />
                      </Tooltip>
                    </span>
                    </div>
                  </>
                )}
                {/* End */}
              </div>
              {/* <div className="product__content">
                <div className="content__title">
                  <h3>About {hit.product_name}</h3>
                </div>
                <div className="product__inner-content">
                  <CKContent content={hit.description} className="custom-class"/>
                  <h6>
                    <strong>Grab your commemorative barrel today!</strong>
                  </h6>
                </div>
              </div> */}
            </div>
            <div className="col-12 col-lg-6">
              <div className="product__info">
                <div className="row">
                  <div className="col-12">
                    {/* <div className="product__heading d-flex justify-content-between">
                      <Typography
                        gutterBottom
                        variant="h2"
                        component="h2"
                        fontSize={24}
                        sx={{
                          fontWeight: 700,
                          color: "#9E874A",
                          lineHeight: "22px",
                        }}
                      >
                        {hit.product_name}
                      </Typography>
                      </div>
                       */}
                  </div>
                </div>
                <div className="product__cart mb-3">
                  <div className="row d-flex flex-wrap justify-content-end align-items-center">
                    <div className="col-auto my-2 my-sm-1 px-1">
                      {/* <Button variant="outlined">
                                                <ArrowBackIcon sx={{ mr: 1 }} />
                                                Back
                                            </Button> */}
                      <div className="price__lable">
                        <CurrencyFormatter
                          amount={hit.price}
                          locale="en-US"
                          currency="USD"
                        />{" "}
                        / Container
                      </div>
                    </div>
                    <div className="col-auto ms-auto my-2 my-sm-1 px-1">
                      <div className="cart__add--btn d-flex justify-content-end">
                        <Tooltip
                          title={errorMessage}
                          arrow
                          open={!!errorMessage}
                        >
                          <ButtonGroup sx={{ alignSelf: "center", my: 1 }}>
                            <Button
                              aria-label="reduce"
                              onClick={() => {
                                if (Math.max(count - 1, 0) < 1) {
                                  setCount(1);
                                  setErrorMessage("");
                                } else {
                                  setCount(Math.max(count - 1, 0));
                                  setErrorMessage("");
                                }
                              }}
                            >
                              <RemoveIcon fontSize="small" />
                            </Button>
                            {/* Replace Button with TextField for input */}
                            <TextField
                              size="small"
                              inputProps={{
                                style: {
                                  textAlign: "center",
                                  width: calculateWidth(count),
                                },
                                "aria-label": "count",
                              }}
                              value={count}
                              onChange={handleQuanityChange}
                            />
                            <Button
                              aria-label="increase"
                              onClick={() => {
                                setCount(count + 1);
                              }}
                            >
                              <AddIcon fontSize="small" />
                            </Button>
                          </ButtonGroup>
                        </Tooltip>

                        <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Add to cart')}>
                        <Button
                          disabled={isLoading}
                          variant="contained"
                          sx={{
                            ml: 1,
                            textTransform: "none",
                            backgroundColor: "#E15A0E",
                            borderRadius: "100px",
                            padding: "10px 48px",
                            height: "42px",
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#FFF",
                            whiteSpace: "nowrap",
                            "&:hover": {
                              backgroundColor: darken("#E15A0E", 0.2),
                            },
                          }}
                          onClick={addToCart}
                        >
                          {isShowViewCart && existingCount == count
                            ? "View Cart"
                            : "Add to Cart"}
                        </Button>
                      </Tooltip>
                      </div>
                      {/* <IconButton sx={{ mr: 1, my: 1 }}>
                                                <FavoriteBorderRoundedIcon sx={{ mr: 1 }} />
                                                <Typography>Add to Wishlist</Typography>
                                                </IconButton> */}
                      {/* <SampleOrder
                                                id={hit.id}
                                                orderDescription={description}
                                                status={status}
                                                onDescriptionUpdate={updateDescription}
                                            /> */}
                    </div>
                  </div>
                  <div className="row d-flex flex-wrap justify-content-end">
                    <div className="col-auto">
                      {hit.is_account_transfer ? (
                        <>
                          <Typography
                            variant="body2"
                            sx={{
                              py: 1,
                              fontSize: "14px",
                              color: "#9E874A",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={AccountTransferIcon}
                              alt="ShippingCrossIcon"
                              className="me-2"
                              width={28}
                              height={24}
                            />
                            Change of Account Required
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="body2"
                            sx={{
                              py: 1,
                              fontSize: "14px",
                              color: "#AFAFB0",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={AccountTransferCrossIcon}
                              alt="ShippingCrossIcon"
                              className="me-2"
                              width={23}
                              height={23}
                            />
                            Change of Account not Required
                          </Typography>
                        </>
                      )}
                    </div>
                    <div className="col-auto ms-auto">
                      {hit.is_relocation_required ? (
                        <>
                          <Typography
                            variant="body2"
                            sx={{
                              py: 1,
                              fontSize: "14px",
                              color: "#9E874A",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <LocalShippingOutlinedIcon
                              sx={{ color: "#9E874A", mr: 1 }}
                            />
                            Relocation Required
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="body2"
                            sx={{
                              py: 1,
                              fontSize: "14px",
                              color: "#AFAFB0",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={ShippingCrossIcon}
                              alt="ShippingCrossIcon"
                              className="me-2"
                              width={30}
                              height={19}
                            />
                            Relocation not Required
                          </Typography>
                        </>
                      )}
                    </div>
                  </div>
                  <hr className="hr-line" />
                  <div className="row">
                    <div
                      className="col-auto my-2 my-sm-1 px-0 ps-1"
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className={`request__sample d-inline-flex align-items-center ${
                          isSample ? "active" : ""
                        }`}
                      >
                        {/* <SampleOrder
                          id={hit.id}
                          inventoryName={hit.product_name}
                          text={true}
                        /> */}
                        <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Request Sample')} arrow>
                          <Button
                            variant="contained"
                            onClick={handleRequestShow}
                          >
                            {/* Request Sample */}
                            <OpacityIcon sx={{ color: "#496673" }} />
                          </Button>
                        </Tooltip>
                        {/* {text && ( */}
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#242424",
                            fontWeight: 600,
                            fontSize: "16px",
                            ml: 1,
                          }}
                          onClick={handleRequestShow}
                        >
                          Request Sample
                        </Typography>
                        {/* )} */}
                      </div>
                    </div>
                    {hit.is_make_an_offer && (
                      <div
                        className="col-auto my-2 my-sm-1 px-0"
                        style={{ cursor: "pointer" }}
                        onClick={handleOfferShow}
                      >
                        <div
                          className={`make__offer d-inline-flex align-items-center ${
                            isOffer ? "active" : ""
                          }`}
                        >
                          {/* <OfferRequest inventoryId={hit.id} /> */}
                          <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Make an Offer')} arrow>
                            <Button variant="contained" sx={{ ml: 2, my: 1 }}>
                              <MonetizationOnOutlinedIcon
                                sx={{ color: "#496673" }}
                              />
                            </Button>
                          </Tooltip>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#242424",
                              fontWeight: 600,
                              fontSize: "16px",
                              ml: 1,
                            }}
                          >
                            Make an offer
                          </Typography>
                        </div>
                      </div>
                    )}
                    <div
                      className="col-auto my-2 my-sm-1 px-0"
                      style={{ cursor: "pointer" }}
                      onClick={manageWishList}
                    >
                      <div className="request__sample d-inline-flex align-items-center">
                        <Button variant="contained">
                          {isInWishlist ? (
                            <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Remove from Wishlist')} arrow>
                              <FavoriteIcon
                                sx={{ cursor: "pointer", color: "red" }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Add to Wishlist')} arrow>
                              <FavoriteBorderIcon
                                sx={{ cursor: "pointer", color: "#A1A1A1" }}
                              />
                            </Tooltip>
                          )}
                        </Button>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#242424",
                            fontWeight: 600,
                            fontSize: "16px",
                            ml: 1,
                          }}
                        >
                          Add to favorites
                        </Typography>
                      </div>
                    </div>
                  </div>
                  
                  {isSample && (
                    <div className="request__sample--details my-3">
                      <div className="card card-body border border-0">
                        <form
                          className="mb-3"
                          onSubmit={handleSubmit(requestSample)}
                          noValidate
                          // validated={sampleRequestValidate}
                        >
                          <div className="mb-3">
                            <div className="row mb-3 g-1">
                              <label className="col-sm-12" htmlFor="purpose">
                                <span className="text-nowrap">
                                  Purpose
                                  <span className="star-required text-danger">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div className="col-sm-12 product-form-group">
                                <select
                                  id="purpose"
                                  required
                                  className={`form-select ${
                                    sampleRequestError.purpose
                                      ? "is_invalid"
                                      : ""
                                  }`}
                                  style={{ cursor: "pointer" }}
                                  value={purpose}
                                  onChange={handlePurposeDropdown}
                                >
                                  <option value="">Select Purpose</option>
                                  <option value="Taste Profile Analysis">
                                    Taste Profile Analysis
                                  </option>
                                  <option value="Product Testing">
                                    Product Testing
                                  </option>
                                  <option value="Quantity Testing">
                                    Quantity Testing
                                  </option>
                                </select>
                                {sampleRequestError.purpose && (
                                  <div className="error-message">
                                    {sampleRequestError.purpose}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="d-flex flex-wrap mb-3 product-form-group">
                              <label className="fw-normal">
                                Multiple container from same lot?{" "}
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </label>
                              <div>
                                <input
                                  type="radio"
                                  id="radioOption1"
                                  className="form-check-inline fw-semibold ps-0"
                                  name="radioOptions1"
                                  value="yes"
                                  onChange={handleRadioChange1}
                                  checked={multipleBarrels === "yes"}
                                  style={{ cursor: "pointer" }}
                                  required
                                />
                                <label htmlFor="radioOption1">Yes</label>
                                <input
                                  type="radio"
                                  id="radioOption2"
                                  className="form-check-inline fw-semibold ps-0"
                                  name="radioOptions1"
                                  value="no"
                                  onChange={handleRadioChange1}
                                  checked={multipleBarrels === "no"}
                                  style={{ cursor: "pointer" }}
                                  required
                                />
                                <label htmlFor="radioOption2" className="ms-2">
                                  No
                                </label>
                              </div>
                              {sampleRequestError.multipleBarrels && (
                                <div className="error-message w-100">
                                  {sampleRequestError.multipleBarrels}
                                </div>
                              )}
                            </div>

                            <div className="d-flex flex-wrap mb-3 product-form-group">
                              <label className="fw-normal">
                                Multiple lots needed?{" "}
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </label>
                              <div>
                                <input
                                  type="radio"
                                  id="radioOption3"
                                  className="form-check-inline fw-semibold ps-0"
                                  name="radioOptions2"
                                  value="yes"
                                  onChange={handleRadioChange2}
                                  checked={multiplelots === "yes"}
                                  style={{ cursor: "pointer" }}
                                  required
                                />
                                <label htmlFor="radioOption3">Yes</label>
                                <input
                                  type="radio"
                                  id="radioOption4"
                                  className="form-check-inline fw-semibold ps-0"
                                  name="radioOptions2"
                                  value="no"
                                  onChange={handleRadioChange2}
                                  checked={multiplelots === "no"}
                                  style={{ cursor: "pointer" }}
                                  required
                                />
                                <label htmlFor="radioOption4" className="ms-2">
                                  No
                                </label>
                              </div>
                              {sampleRequestError.multipleLots && (
                                <div className="error-message w-100">
                                  {sampleRequestError.multipleLots}
                                </div>
                              )}
                            </div>

                            <div className="row mb-3">
                              <div className="col-md-6 product-form-group">
                                <div className="row d-flex flex-column">
                                  <label htmlFor="size" className="col">
                                    Size Needed?{" "}
                                    <span className="star-required text-danger">
                                      *
                                    </span>
                                  </label>
                                  <div className="col">
                                    <select
                                      id="size"
                                      className={`form-select ${
                                        sampleRequestError.size
                                          ? "is_invalid"
                                          : ""
                                      }`}
                                      style={{ cursor: "pointer" }}
                                      value={size}
                                      onChange={handleSizeDropdown}
                                      required
                                    >
                                      <option value="">Select Size</option>
                                      <option value="750mL">750mL</option>
                                      <option value="200mL">200mL</option>
                                      <option value="100mL">100mL</option>
                                    </select>
                                    {sampleRequestError.size && (<div className="error-message">{sampleRequestError.size}</div>)}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 product-form-group">
                                <div className="row d-flex flex-column">
                                  <label htmlFor="quantity" className="col">
                                    Qty Requested of Size{" "}
                                    <span className="star-required text-danger">
                                      *
                                    </span>
                                  </label>
                                  <div className="col">
                                    <input
                                      id="quantity"
                                      className={`form-control ${
                                        sampleRequestError.quantity
                                          ? "is_invalid"
                                          : ""
                                      }`}
                                      required
                                      type="text"
                                      value={quantity}
                                      //onKeyDown={handleKeyDown}
                                      onChange={handleInputTextChange}
                                      placeholder="Enter Qty..."
                                    />
                                    {sampleRequestError.quantity && (
                                      <div className="error-message">
                                        {sampleRequestError.quantity}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mb-3 form__inner">
                              <label htmlFor="description">
                                Request Notes{" "}
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </label>
                              <textarea
                                id="description"
                                className={`form-control textarea ${
                                  sampleRequestError.requestNote
                                    ? "is_invalid"
                                    : ""
                                }`}
                                aria-label="With textarea"
                                value={description}
                                onChange={handleInputChange}
                                rows={3}
                                style={{ resize: "none" }}
                                placeholder="Enter notes..."
                                required
                              ></textarea>
                              <p className="d-flex mt-1">
                                {sampleRequestError.requestNote && (
                                  <span className="error-message mt-0">{sampleRequestError.requestNote}</span>
                                )}
                                <span className="ms-auto">
                                  {description.length}/500
                                </span>
                              </p>
                            </div>

                            <div className="text-end border-top border-dark-subtle pt-3">
                              <button
                                className="secondary-btn"
                                onClick={handleRequestSampleCancel}
                                disabled={isLoading}
                                type="button"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="primary-btn ms-2"
                                disabled={isLoading}
                              >
                                {isLoading && (
                                  <Spinner className="spinner-border spinner-border-sm me-2" />
                                )}{" "}
                                Submit Request
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}

                  {isOffer && (
                    <form
                      className="mb-3"
                      onSubmit={handleSubmit(offerRequest)}
                      noValidate
                    >
                      <div className="make__offer--details my-3">
                        <div className="card card-body row d-flex flex-row border border-0 mx-0">
                          <div className="col-md-6 ps-md-0">
                            <div className="d-flex align-items-center mb-4 flex-wrap">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#242424",
                                  fontWeight: 600,
                                  fontSize: "16px",
                                  mr: 1,
                                  textWrap: "nowrap",
                                }}
                              >
                                Price / Container{" "}
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </Typography>
                              <div className="position-relative form__inner" style={{width:"100px"}}>
                                <input
                                  type="number"
                                  value={formData.pricePerBarrel}
                                  id="price-per-barrel"
                                  placeholder="Price($)"
                                  // size="small"
                                  onChange={handlePriceChange}
                                  onKeyDown={handleKeyDown}
                                  // sx={{ width: "100%" }}
                                  // rows={1}
                                  // style={{resize:"none"}}
                                  min={1}
                                  className={`form-control ${
                                    offerRequestValidate &&
                                    !formData.pricePerBarrel
                                      ? "is_invalid"
                                      : ""
                                  }`}
                                />
                                {offerRequestValidate &&
                                  !formData.pricePerBarrel && (
                                    <div className="error-message position-absolute">
                                      Please enter price
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 pe-md-0">
                            <div className="d-flex align-items-center mb-4 flex-wrap">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#242424",
                                  fontWeight: 600,
                                  fontSize: "16px",
                                  mr: 1,
                                  textWrap: "nowrap",
                                }}
                              >
                                Containers{" "}
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </Typography>
                              <div className="position-relative form__inner" style={{width:"100px",}}>
                                <input
                                  type="number"
                                  value={formData.quantity}
                                  id="quantity"
                                  placeholder="Quantity"
                                  // size="small"
                                  onChange={handleQuantityChange}
                                  onKeyDown={handleKeyDown}
                                  min={1}
                                  // sx={{ width: "100%" }}
                                  className={`form-control ${
                                    offerRequestValidate && !formData.quantity
                                      ? "is_invalid"
                                      : ""
                                  }`}
                                  required
                                />
                                {offerRequestValidate && !formData.quantity && (
                                  <div className="error-message position-absolute">
                                    Please enter quantity
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 px-0">
                            <div className="row g-2 mb-3">
                              <div className="col-xxl-6">
                                {!hit.is_account_transfer && (
                                  <label className="d-flex">
                                    <Checkbox
                                      sx={{
                                        color: "#AFAFB0",
                                        height: "max-content",
                                        p: 0,
                                        mr: 1,
                                        "&.Mui-checked": {
                                          color: "#6750A4",
                                          "& .MuiSvgIcon-root": {
                                            backgroundColor: "transparent",
                                          },
                                        },
                                      }}
                                      onChange={manageServiceFees}
                                    />
                                    <span>I would like to change account</span>
                                  </label>
                                )}
                              </div>
                              <div className="col-xxl-6">
                                {!hit.is_relocation_required && (
                                  <label className="d-flex">
                                    <Checkbox
                                      sx={{
                                        color: "#AFAFB0",
                                        height: "max-content",
                                        p: 0,
                                        mr: 1,
                                        "&.Mui-checked": {
                                          color: "#6750A4",
                                          "& .MuiSvgIcon-root": {
                                            backgroundColor: "transparent",
                                          },
                                        },
                                      }}
                                      onChange={manageHandlingFees}
                                    />
                                    <span>
                                      I would like to relocate container
                                    </span>
                                  </label>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            {/* <div className="d-flex flex-column border-top border-dark-subtle py-2">
                              <div className="text-end my-3">
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#242424",
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  Total Handling Fees:{" "}
                                  <CurrencyFormatter
                                    amount={formData.handlingFee}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                </Typography>
                              </div>
                              <div className="text-end my-3">
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#242424",
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  Total Service Fees:{" "}
                                  <CurrencyFormatter
                                    amount={formData.serviceFee}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                </Typography>
                              </div>
                            </div> */}
                          </div>
                          <div className="col-12 px-0">
                            <div className="d-flex flex-column border-top border-dark-subtle pt-3">
                              <div className="text-end my-2">
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#242424",
                                    fontWeight: 600,
                                    fontSize: "20px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  Total offer:{" "}
                                  <CurrencyFormatter
                                    amount={formData.totalAmount}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                </Typography>
                              </div>
                              <div className="text-end my-2">
                                <button
                                  className="secondary-btn"
                                  onClick={handleOfferCancel}
                                  disabled={isLoading}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  className="primary-btn ms-2"
                                  disabled={isLoading}
                                >
                                  {isLoading && (
                                    <Spinner className="spinner-border spinner-border-sm me-2" />
                                  )}{" "}
                                  Submit Offer
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
                <TableContainer
                  component={Paper}
                  className={classes.root}
                  sx={{ mt: 3 }}
                >
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Producer
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {" "}
                          {hit.producer}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Container Condititon
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit?.container_cooperage !== ''
                              ? hit?.container_cooperage
                              : 'Unknown'}
                        </TableCell>
                      </TableRow>
                      {/* <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Price
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          <CurrencyFormatter
                            amount={hit.price}
                            locale="en-US"
                            currency="USD"
                          />
                          / barrel
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Volume
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {" "}
                          {hit.volume.toFixed(2)} {hit.volume_unit}
                        </TableCell>
                      </TableRow> */}
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Container Size
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.barrel_size} gallons
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Mash Bill
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.mash_bill}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                      <TableCell
                        className={classes.firstColumn}
                        sx={{ verticalAlign: "top" }}
                      >
                        Proof
                      </TableCell>
                      <TableCell
                        className={classes.secondColumn}
                        sx={{ verticalAlign: "top" }}
                      >
                        {hit.proof != '0'
                            ? `${CommonService.formatToSingleDecimal(hit.proof)} pf`
                            : 'Unknown'}
                      </TableCell>
                      </TableRow>
                      {/* <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Proof Gallons
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.proof_gallons} pf-gal
                        </TableCell>
                      </TableRow> */}
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Age
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {/* {hit.spirit_age_year} years {hit.spirit_age_month}{" "}
                          months */}
                          {years} years {months} months
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Spirit Type
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.ttb_type}
                        </TableCell>
                      </TableRow>
                      
                      {/* Start Line --- This will be enabled once the lot-wise sell request feature is developed. */}
                      {/* <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Tasting notes
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          <div className="taste-precentage">
                            <label className="d-flex align-items-center justify-content-between gap-1"><span>Earthiness</span><span>3/5</span></label>
                          <Slider
                            disabled
                            defaultValue={30}
                            aria-label="Disabled slider"
                            sx={{
                              "&.Mui-disabled": {
                                color: "#0C3344",
                              },
                              "& .MuiSlider-thumb": {
                                display: "none",
                              },
                              height: "8px",
                              color: "#0C3344",
                            }}
                          />
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={2} className="tasting-note-detail-wrapper">
                          <div className="row gy-3">
                            <div className="col-12">
                              <div className="field">
                                <div className="label">Nose</div>
                                <div className="value">Warm baking spice and cracked black pepper upfront, followed by toasted oak, light citrus zest, and herbal rye grain. Subtle vanilla bean and dried apricot appear as the spirit opens.</div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="field">
                                <div className="label">Palate</div>
                                <div className="value">Sweet caramel and honey at the entry, evolving into bold rye spice and pepper. Medium-bodied mouthfeel with toasted cereal, hints of cocoa, and orange peel. Spice builds mid-palate with good structure.</div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="field">
                                <div className="label">Finish</div>
                                <div className="value">Long and warming finish with lingering clove, oak tannins, mint, and a lightly sweet fade. Dry and slightly earthy aftertaste.</div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="field description-field">
                                <div className="label">Sensory Scores</div>
                                <div className="value">
                                  <div className="row">
                                    <div className="col-6">
                                      <div className="taste-precentage">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Sweetness</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="taste-precentage ms-sm-auto">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Spice</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="taste-precentage">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Earthiness</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="taste-precentage ms-sm-auto">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Fruitiness</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="taste-precentage">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Oak Presence</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="taste-precentage ms-sm-auto">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Balance</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                    <div className="col-12">
                                      <div className="taste-precentage w-100 mw-100">
                                        <label className="d-flex align-items-center justify-content-between gap-1"><span>Overall Score</span><span>3/5</span></label>
                                        <Slider defaultValue={1} aria-label="Default" max={5} disabled valueLabelDisplay="auto" sx={{
                                          height: "8px", color: "#0C3344", "&.Mui-disabled": {
                                            color: "#0C3344",
                                          },
                                          "& .MuiSlider-thumb": {
                                            display: "none",
                                          },
                                        }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="field">
                                <div className="label">Blend Group</div>
                                <div className="value">Warm baking spice and cracked black pepper upfront, followed by toasted oak, light citrus zest, and herbal rye grain. Subtle vanilla bean and dried apricot appear as the spirit opens.</div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="field">
                                <div className="label">Color</div>
                                <div className="value color-value">
                                  <div></div>
                                  <span>Deep Gold</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow> */}
                      {/* End Line --- This will be enabled once the lot-wise sell request feature is developed. */}


                      {/* <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Tasting Note
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.tasting_note}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Stage
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.stage}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Facility
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.facility}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Lot Id
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.lot_no}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Container Id
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.barrel_number}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Fill Date
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.fill_date}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Container Id
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.barrel_number}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Container Profile
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.barrel_profile}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Cost
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          ${hit.barrel_cost}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.firstColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          className={classes.secondColumn}
                          sx={{ verticalAlign: "top" }}
                        >
                          {hit.ttb_type}
                        </TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="row">
                  <div className="col-12">
                    <Typography
                      variant="h5"
                      sx={{ mb: 1, pb: 0, borderTop: "2px solid #ABABAB" }}
                    >
                      About {hit.ttb_type}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <CKContent
                        content={hit.description}
                        className="custom-class"
                      />
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>
      {/* End */}

      {/* <section className="customer--view__cart my-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="row d-flex justify-content-between align-items-center">
                                <div className="col-auto">
                                    <Typography variant="h5" sx={{ mb: 2 }}>
                                        My Cart
                                    </Typography>
                                </div>
                                <div className="col-auto">
                                    <Button variant="outlined">Clear Cart</Button>
                                </div>
                            </div>
                            <div className="row">
                                <List sx={{ bgcolor: 'background.paper' }}>
                                    <ListItem sx={{ fontSize: '16px' }}>
                                        <div className="row d-flex w-100">
                                            <div className="col-2">
                                                <div className="row">
                                                    <img src={BourbonWhiskyBarrel} alt="BourbonWhiskyBarrel" />
                                                </div>
                                            </div>
                                            <div className="col-10">
                                                <div className="row">
                                                    <div className="col-lg-7 mb-2 mb-lg-0">
                                                        <Typography variant="h5" sx={{ mb: 1, fontWeight: 800, color: '#1E5EFF' }}>Bourbon Whisky</Typography>
                                                        <div className="row">
                                                            <div className="col-auto">
                                                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 700, fontSize: '16px' }}>2+ Years Old</Typography>
                                                            </div>
                                                            <div className="col-auto">
                                                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 700, fontSize: '16px' }}>53 Gal</Typography>
                                                            </div>
                                                            <div className="col-auto">
                                                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 700, fontSize: '16px' }}>C(60%) / R(33%) / W(0%) / MB (7%)</Typography>
                                                            </div>
                                                        </div>
                                                        <div className="row d-flex">
                                                            <div className="col-auto mb-2">
                                                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '16px' }}>Purpose: </Typography>
                                                            </div>
                                                            <div className="col-9 ps-0">
                                                            <Typography variant="body2" sx={{ fontSize: '16px' }}>For investment purposes and to build a collection of rare and sought-after bottles</Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5">
                                                        <div className="row d-flex justify-content-lg-center">
                                                            <div className="col-auto">
                                                                <ButtonGroup>
                                                                    <Button
                                                                        aria-label="reduce"
                                                                        onClick={() => {
                                                                            setCount(Math.max(count - 1, 0));
                                                                        }}
                                                                    >
                                                                        <RemoveIcon fontSize="small" />
                                                                    </Button>
                                                                    <Button>
                                                                        {count}
                                                                    </Button>
                                                                    <Button
                                                                        aria-label="increase"
                                                                        onClick={() => {
                                                                            setCount(count + 1);
                                                                        }}
                                                                    >
                                                                        <AddIcon fontSize="small" />
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </div>
                                                            <div className="col-auto">
                                                                <Button variant="text"><DriveFileRenameOutlineOutlinedIcon  sx={{ mr: 1 }}/>Edit</Button>
                                                            </div>
                                                            <div className="col-auto">
                                                                <Button variant="text"><DeleteOutlinedIcon  sx={{ mr: 1 }}/>Remove</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ListItem>
                                </List>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className='border border-secondary-subtle p-2 h-100'>
                                <div className="row d-flex justify-content-between align-items-center">
                                    <div className="col-auto">
                                        <Typography variant="h5" sx={{ mb: 2 }}>
                                            Summary
                                        </Typography>
                                    </div>
                                </div>
                                <div className="row px-3">
                                    <List sx={{ bgcolor: 'transparent', borderBottom: '1px solid #C4C8CB' }}>
                                        <ListItem sx={{ pr: 0 }}>
                                            <div className="row d-flex justify-content-between align-items-center w-100">
                                                <div className="col-auto">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-auto">
                                                            <div className="row d-flex flex-column">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span" sx={{ mb: 2 }}>
                                                                        Bourbon Whisky
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        $2,050 / barrel
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="row d-flex">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        <CloseOutlinedIcon />
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        5
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <Typography variant="body1">
                                                        $10,250.00
                                                    </Typography>
                                                </div>
                                            </div>
                                        </ListItem>
                                        <ListItem sx={{ pr: 0 }}>
                                            <div className="row d-flex justify-content-between align-items-center w-100">
                                                <div className="col-auto">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-auto">
                                                            <div className="row d-flex flex-column">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span" sx={{ mb: 2 }}>
                                                                        Bourbon Whisky
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        $2,050 / barrel
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="row d-flex">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        <CloseOutlinedIcon />
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        5
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <Typography variant="body1">
                                                        $10,250.00
                                                    </Typography>
                                                </div>
                                            </div>
                                        </ListItem>
                                        <ListItem sx={{ pr: 0 }}>
                                            <div className="row d-flex justify-content-between align-items-center w-100">
                                                <div className="col-auto">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-auto">
                                                            <div className="row d-flex flex-column">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span" sx={{ mb: 2 }}>
                                                                        Bourbon Whisky
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        $2,050 / barrel
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="row d-flex">
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        <CloseOutlinedIcon />
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Typography variant="body1" component="span">
                                                                        5
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <Typography variant="body1">
                                                        $10,250.00
                                                    </Typography>
                                                </div>
                                            </div>
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="row d-flex justify-content-end p-2">
                                    <div className="col-auto">
                                        <Typography variant="h6">Total Price</Typography>
                                    </div>
                                    <div className="col-auto">
                                        <Typography variant="h6">$16,910.00</Typography>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-end px-2">
                                    <div className="col-auto">
                                        <Typography variant="body2">Ownership Transfer Fee and Transport Fee are excluded</Typography>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-center py-3">
                                    <div className="col-auto">
                                    <Button variant="contained">Place Order Request</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
    </>
  );
};

// const CustomHits = ({ children }) => {
//   // useInstantSearch gives you access to the search status
//   const { status } = useInstantSearch();

//   const { hits } = useHits();

//   if (!hits || hits.length === 0) {
//     return <div>No results found. Please try different filters.</div>;
//   }
//   return (
//     <>
//       {status === 'loading' ? (

//         <Container maxWidth="sm" className="loading-wrapper" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
//           <Spinner animation="border" variant="secondary" className="mt-3" />
//           <Typography variant="subtitle1" sx={{ fontSize: '20px', fontWeight: 600, color: '#737376', marginTop: '12px' }}>
//             Loading Product Details...
//           </Typography>
//         </Container>

//       ) : (
//         children
//       )}
//     </>
//   );
// };
const CustomHits = ({ children }) => {
  // Access the search status and results using hooks
  const { status } = useInstantSearch();
  const { hits } = useHits();
  const hasSearched = useRef(false);

  useEffect(() => {
    if (status === "loading" || status === "stalled") {
      return;
    }
    hasSearched.current = true;
  }, [status]);

  const isLoading = status === 'loading' || status === 'stalled';

  if (isLoading) {
    return (
      <Container maxWidth="sm" className="loading-wrapper" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
        {/* You can use either MUI's CircularProgress or React-Bootstrap's Spinner */}
        <CircularProgress color="secondary" />
        <Typography variant="subtitle1" sx={{ fontSize: '20px', fontWeight: 600, color: '#737376', marginTop: '12px' }}>
          Loading Products...
        </Typography>
      </Container>
    );
  }

  if (hasSearched.current && status === "idle" && hits.length === 0) {
    return (
      <Container className="loading-wrapper" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
        <ProductionQuantityLimitsOutlinedIcon sx={{fontSize:80,color:"#333"}}/>
        <Typography variant="h6">Out of Stock</Typography>
        <Typography variant="body1" color="text.secondary">
          This Product is no longer available...
        </Typography>
      </Container>
    );
  }

  return (
    <>
      {React.cloneElement(children, { hits })}
    </>
  );
};

export default ProductDetail;